import React, { useCallback, useState } from 'react';
import { loginUser } from '@/store/user/userActions';
import { LoginUserProps } from '@/interfaces/user';
import { useAppDispatch, useAppSelector } from '@/hooks/redux';
import LoginForm from '@/components/organisms/LoginForm';
import MyNav2 from '@/components/templates/MyNav2';


const Actividades: React.FC = () => {


  const [isOpen, setisOpen] = useState(false);
  const menuClass = `col-12 my-3 collapse ${isOpen ? " show" : ""}`;
  const toggleOpen = () => setisOpen( !isOpen);

  const dispatch = useAppDispatch();


  return (
    <>
      <header className="actividades">
      <MyNav2/>
    {/* Breadcrumb */}
    <section className="container d-none d-lg-block mt-2">
      <div className="row">
        <div className="col-12">
          <div className="border-top py-2">
            <nav style={{}} aria-label="breadcrumb">
              <ol className="breadcrumb breadcrumb-light">
                <li className="breadcrumb-item">
                  <a href="/">Inicio</a>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  Actividades
                </li>
              </ol>
            </nav>
          </div>
        </div>
      </div>
    </section>
    {/* Titulo */}
    <section className="container text-white">
      <div className="row">
        <div className="col-md-9 col-lg-6 my-5">
          <h1 className="display-3 mt-5">Actividades</h1>
          <p className="lead mb-5">
            El Camino de Humano Puente es un camino de crecimiento personal. Es
            una manera de vivir la vida. Es un proceso único de descubrimiento,
            mayormente gracias al síntoma, del verdadero objetivo de vida que se
            había olvidado. El síntoma viene siempre a decir la verdad.
          </p>
        </div>
      </div>
    </section>
    </header>
    <section className="container py-5">
      <div className="row">
        <div className="col-lg-6">
          <h2 className="text-secondary">Las Actividades</h2>
        </div>
        <div className="col-lg-6">
          <p className="mb-3">
            Humano Puente continua creciendo dia a dia en todo el Mundo. Gracias!
            Siempre con el propósito de que este conocimiento pueda llegar a toda
            la Madre Tierra, hoy contamos con la posibilidad de hacer este camino{" "}
            <strong>completo</strong> desde toda la Madre Tierra para ser{" "}
            <strong>Consultor/a en Bioexistencia Consciente</strong>, el más
            profundo de los pasos y el tercero de este camino. Hoy es posible
            tambien hacer todo <strong>modo online</strong>. Para informarse le
            sugerimos recorrer el contenido de esta solapa y la de{" "}
            <strong>
              <a href="/camino">Cómo hacer el camino de Humano Puente</a>
            </strong>
            .
          </p>
          <a
            onClick={toggleOpen}
            className="btn btn-outline-primary"
            data-bs-toggle="collapse"
            id="toggle"

            href="#hiddenContent"
            role="button"
            aria-expanded="false"
            aria-controls="collapseExample"
          >
            {(isOpen)?'-':'+'} info
          </a>
        </div>
        <div      className={menuClass}    >
          <hr />
          <h6 className="text-secondary mb-4">Pasos para ser un Humano Puente</h6>
          <p>
            Amigos: Gracias por los mails, el amor y las solicitudes que nos
            llegan. Les comentamos aquí el modo de hacer el primer paso, la
            Jornada Online.
          </p>
          <h4 className="text-primary">
            ¿Qué son las jornadas Online de Humano Puente?
          </h4>
          <p>
            El resumen de esta vivencia se podría enmarcar como una gran consulta
            y una enorme toma de conciencia que provoca en muchos casos el
            replanteo de toda una manera de ver y vivir la vida, donde se comienza
            a ver la vida desde la mirada nueva que otorga este campo, a conocer
            sus herramientas básicas, a comprender{" "}
            <strong>para que cosa buena</strong> llega en determinado momento un
            hecho que es considerado traumático y que nosotros llamamos{" "}
            <strong>informedad</strong>, cual es su mensaje, qué debemos hacer
            para que ya no sea necesaria. Esto es muy importante para que nuestra
            parte consciente, lógica, comprenda y acepte los motivos por los que
            la Decodificación Bioemocional, primer paso de la{" "}
            <strong>Bioexistencia Consciente</strong> realmente funciona. Es aquí
            donde personas de, por ejemplo, un pensamiento concreto, científico,
            comprenden que son las fuerzas previas a cada cosa las que realmente
            determinan su existencia.{" "}
          </p>
          <p>
            Luego de esta actividad, que puede llevar desde días hasta semanas
            poder recorrer, todos comprenden por qué este camino decimos que no es
            un metodo de sanación de enfermedades, sino de reencuentro del Ser con
            su camino. Solo utilizamos el síntoma para ingresar al SER que
            verdaderamente eres, esa es la única e importantísima finalidad que
            para nosotros tiene cada síntoma. Este es el primer paso para quienes
            desean ser <strong>Consultores en Bioexistencia Consciente</strong>.
            Para seguir este camino maravilloso hay que hacer luego la Apertura en
            Decodificación Bioemocional y la Apertura en Bioexistencia Consciente.
            Hay un video específico sobre este tema en esta <strong>web</strong>.
          </p>
          <p>
            Otra manera <strong>maravillosa</strong> de comenzar este camino es
            gracias a que hoy existen los{" "}
            <strong>Comunicadores de Humano Puente</strong> que bridan las{" "}
            <strong>Charlas Introductorias de un día</strong>. Esta manera es
            óptima por dos motivos: 1- Al hacerla contarás con la parte presencial
            o en <strong>Vivo Online</strong> y 2- Por participar de la charla
            sólo abonarás el 50% del valor de la Jornada online y, de ese modo,
            tendrás las dos cosas a un precio menor que el que abonarías si sólo
            hicieras las Jornadas online.
          </p>
          <p>
            Para obtener información para ser Consultor en Bioexistencia
            Consciente, pedimos enviar un mail a organizacionhp@gmail.com o
            completar el fomulario de contacto (revisar casilla de Spam si no
            llega una respuesta en 72 hs). Para hacer las Aperturas es requisito
            haber realizado previamente la Jornada Online. ya sea que la hayas
            hecho luego de una charla introductoria o no.
          </p>
          <p>
            Sugerimos también dar este primer paso también antes de una consulta
            individual. Si desea ver el listado de Consultores en Bioexistencia
            Consciente podrá verlos en la solapa{" "}
            <strong>
              <a href="/consultores">Consultores</a>
            </strong>
            .
          </p>
          <p>
            Gracias, en lo posible recomendamos ver todo el material de la sección{" "}
            <strong>
              <a href="/video">Video</a>
            </strong>
            . Un abrazo.
          </p>
        </div>
      </div>
    </section>
    <section className="container text-center mb-5">
      <div className="row">
        <div className="col-md-6 p-md-5 actividad-border">
          <img src="/img/hp_iso.svg" alt="" className="big-icon mt-5 mb-3" />
          <h1 className="mb-3">
            Hacer el Camino
            <br />
            Humano Puente
          </h1>
          <a
            className="btn btn-outline-primary mb-5"
            href="/caminohp"
            role="button"
          >
            ver todas las actividades
          </a>
        </div>
        <div className="col-md-6 p-md-5 actividad-border">
          <img src="./img/seminarios.svg" alt="" className="big-icon mt-5 mb-3" />
          <h1 className="mb-3">
            Seminarios, Encuentros
            <br />y otras Actividades
          </h1>
          <a
            className="btn btn-outline-primary mb-5"
            href="/seminarios"
            role="button"
          >
            ver todas las actividades
          </a>
        </div>
      </div>
    </section>

  </>

  );
};

export default Actividades;
